import { Button, Modal } from 'react-bootstrap';
import { FC, useCallback } from 'react';

interface SimpleConfirmModalProps {
    isOpen: boolean;
    toggle(): void;
    title: string;
    bodyText?: string;
    onConfirm(): any;
    confirmText?: string;
    cancelText?: string;
    variant?: 'danger' | 'warning' | 'primary';
}

const SimpleConfirmModal: FC<SimpleConfirmModalProps> = ({
    isOpen,
    toggle,
    title,
    bodyText,
    onConfirm,
    confirmText = 'Подтвердить',
    cancelText = 'Отмена',
    variant = 'danger'
}) => {

    const handleConfirm = useCallback(() => {
        onConfirm();
        toggle();
    }, [onConfirm, toggle]);

    return (
        <Modal show={isOpen} onHide={toggle} centered>
            <Modal.Header closeButton>
                {title}
            </Modal.Header>
            <Modal.Body>
                {bodyText || 'Вы уверены?'}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="link" className="text-secondary fw-medium" onClick={toggle}>
                    {cancelText}
                </Button>
                <Button variant={variant} onClick={handleConfirm}>
                    {confirmText}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default SimpleConfirmModal;
